const state = {
  navbarTitle: 'Exide',
  message: null
};

const mutations = {
  setNavbarTitle(state, data) {
    state.navbarTitle = data;
  },
  setMessage(state, data) {
    state.message = data;
  }
};

const getters = {
  getMessage: state => state.message
};

const actions = {
  setMessage: ({ commit }, payload) => {
    commit('setMessage', payload);
  }
};

export default {
  state,
  mutations,
  getters,
  actions
};
